import { PaymentModes, UserRolePermissions } from '../../constants';
import { checkSitePermission } from '../../store/slices/user';
import getTripItineraries from '../getTripItineraries';

const checkDoChargeAgencyPlanningFees = (tripId) => (store) => {
  let canCharge = checkSitePermission(UserRolePermissions.canChargeAgencyPlanningFees)(store);

  // For now, charge agency planning fees only when CASH payment is disabled.
  // In this case, the user will apply a markup instead
  if (
    store.trip &&
    store.trip.paymentMethods &&
    Object.values(store.trip.paymentMethods).find((p) => p.paymentMode === PaymentModes.CASH)
  ) {
    return false;
  }

  if (
    store.user.travelAgency &&
    (store.user.travelAgency.chargeAgencyFeesForTravelType === undefined ||
      store.user.travelAgency.chargeAgencyFeesForTravelType === null)
  ) {
    return canCharge;
  }
  const trip = store.trip && store.trip.selectedTrips && store.trip.selectedTrips[tripId];
  let bookedTravelTypes = trip?.bookedTravelTypes;
  if (trip && bookedTravelTypes === undefined) {
    bookedTravelTypes = getTripItineraries(trip).map((r) => r.mode);
  }
  if (
    canCharge &&
    trip &&
    bookedTravelTypes &&
    store.user.travelAgency &&
    store.user.travelAgency.chargeAgencyFeesForTravelType !== null &&
    store.user.travelAgency.chargeAgencyFeesForTravelType !== undefined &&
    bookedTravelTypes.indexOf(store.user.travelAgency.chargeAgencyFeesForTravelType) === -1
  ) {
    canCharge = false;
  }
  return canCharge;
};

export default checkDoChargeAgencyPlanningFees;
